import { render, staticRenderFns } from "./MediaDelete.vue?vue&type=template&id=61322d18"
import script from "./MediaDelete.vue?vue&type=script&lang=ts"
export * from "./MediaDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports